import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

// Modal de alta/edición del texto de una tarjeta (spec 006, RF-7/RF-8). Bespoke, concepto tomado de
// NewCard/AddActivity de ProductBacklog/CustomComponents (sin importar react-trello, FA-2). Props
// tipables (listo para TS, §6.10).
//
// Props:
//  - show: boolean
//  - onHide: () => void
//  - initialText: string (vacío en alta)
//  - saving: boolean
//  - onSave: (texto: string) => void
//  - editing: boolean (título del modal)
//  - t: i18next (namespace "retroBoard")
const RetroCardModal = ({ show, onHide, initialText = "", saving = false, onSave, editing = false, t }) => {
  const [texto, setTexto] = useState(initialText);

  useEffect(() => {
    if (show) setTexto(initialText || "");
  }, [show, initialText]);

  const handleSave = () => {
    const trimmed = (texto || "").trim();
    if (!trimmed) return;
    onSave(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="border-0 shadow-lg">
      <Modal.Header>
        <Modal.Title className="h5">
          {editing ? t("retro_card_modal_edit_title") : t("retro_card_modal_create_title")}
        </Modal.Title>
        <Button variant="light" onClick={onHide} aria-label="Close">
          X
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            {t("retro_card_label_texto")}
            <span className="text-primary"> *</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            autoFocus
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            placeholder={t("retro_card_placeholder")}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={onHide} disabled={saving}>
          <i className="fa fa-times mr-2" />
          {t("retro_btn_cancel")}
        </Button>
        <Button variant="success" onClick={handleSave} disabled={saving || !(texto || "").trim()}>
          {saving ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <>
              <i className="fa fa-save mr-2" />
              {t("retro_btn_save")}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RetroCardModal;
